export interface ParkingProduct {
  name: string;
  image: string;
}

export interface ParkingProductCategory {
  key: string;
  name: string;
  en: string;
  tagline: string;
  products: ParkingProduct[];
}

export const parkingProductsHero = {
  eyebrow: '智慧停车产品',
  title: '两大类智慧停车硬件',
  titleHighlight: '覆盖路内泊位与停车场全场景',
  subtitle:
    '路内停车设备与停车场设备两大类，覆盖车辆探测、身份识别、通道控制、诱导引导与视频取证等停车全场景终端。',
  desc: '共 15 款标准化设备，适配城市道路、路内泊位、公共停车场与园区车场，支持项目集成与批量采购。',
};

export const parkingProductCategories: ParkingProductCategory[] = [
  {
    key: 'onstreet',
    name: '路内停车设备',
    en: 'On-street Parking',
    tagline: '车辆探测 · 无线组网 · 手持取证',
    products: [
      {
        name: 'LORA车辆探测器',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692584.png',
      },
      {
        name: 'NB-IOT车辆探测器',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692584.png',
      },
      {
        name: '网关',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692587.png',
      },
      {
        name: 'PDA手持终端',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692589.png',
      },
      {
        name: '车载卡',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692590.png',
      },
      {
        name: 'RFID读卡器',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692591.png',
      },
      {
        name: 'RFID雷达探测读卡器',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692586.png',
      },
      {
        name: 'AI智能停车视频取证巡检终端',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/52330980.png',
      },
    ],
  },
  {
    key: 'parking-lot',
    name: '停车场设备',
    en: 'Parking Lot',
    tagline: '通道控制 · 车牌识别 · 诱导引导',
    products: [
      {
        name: '高速道闸',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693318.png',
      },
      {
        name: '车牌识别一体机',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693317.png',
      },
      {
        name: '显示屏幕',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24696576.png',
      },
      {
        name: '补光灯',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693316.png',
      },
      {
        name: '车位锁',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693321.png',
      },
      {
        name: '诱导屏',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693320.png',
      },
      {
        name: '吊顶式车辆探测器',
        image:
          'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692585.png',
      },
    ],
  },
];